/* global
actualCostsCreateUrl configsUrl departmentsUrl generateReportUrl
previewCachedUrl previewRefreshUrl
reportConfigsIndexUrl reportConfigsStoreUrl reportConfigsDeleteUrl
locationType
*/

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ActualVsBudgetReportCriteria from './ActualVsBudgetReportCriteria';
import ActualVsBudgetReportTable from './ActualVsBudgetReportTable';
import { ActualVsBudgetReportProvider } from './context/ActualVsBudgetReportContext';

import SectionTile from 'CommonComponents/SectionTile';

export default function ActualVsBudgetReport(props) {
    const [configCollapsed, setConfigCollapsed] = useState(false);

    return (
        <div className="tw-h-full tw-flex tw-flex-col">
            <div className="tw-flex-auto tw-flex tw-flex-col tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary tw-space-y-7">
                <div className="tw-flex-initial">
                    <SectionTile
                        flat
                        header={$t('Report')}
                        subHeader={$t('Configure and generate an Actuals vs Budget report')}
                        collapsed={configCollapsed}
                        onToggle={() => setConfigCollapsed(!configCollapsed)}
                        visibly
                    >
                        <ActualVsBudgetReportCriteria fetchDepartmentsUrl={departmentsUrl} />
                    </SectionTile>
                </div>
                <div className="tw-flex-auto">
                    <ActualVsBudgetReportTable />
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('ActualVsBudgetReport')) {
    var rootEl = document.getElementById('ActualVsBudgetReport');
    ReactDOM.render(
        <App>
            <ActualVsBudgetReportProvider
                fetchConfigsUrl={configsUrl}
                module={locationType}
                actualCostsCreateUrl={actualCostsCreateUrl}
                generateReportUrl={generateReportUrl}
                previewCachedUrl={previewCachedUrl}
                previewRefreshUrl={previewRefreshUrl}
                reportConfigsIndexUrl={reportConfigsIndexUrl}
                reportConfigsStoreUrl={reportConfigsStoreUrl}
                reportConfigsDeleteUrl={reportConfigsDeleteUrl}
            >
                <ActualVsBudgetReport />
            </ActualVsBudgetReportProvider>
        </App>,
        rootEl,
    );
}
